/**
 * Model Options Utility
 * Centralized configuration for AI model options
 */

export interface ModelOption {
    value: string;
    label: string;
}

export const modelOptions: ModelOption[] = [
    { value: "gemini-pro", label: "Gemini Pro" },
    { value: "gemini-2", label: "Gemini Flash 2" },
    { value: "gemini-2-5-flash", label: "Gemini Flash 2.5" },
    { value: "gemini-2-5-pro", label: "Gemini Pro 2.5" },
    { value: "gemini-experimental", label: "Gemini Experimental" },
    { value: "gpt-4o", label: "GPT-4o" },
    { value: "gpt-4o-mini", label: "GPT-4o Mini" },
    { value: "gpt-4.1", label: "GPT-4.1" },
    { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
    { value: "o3-mini", label: "O3 Mini" },
];

export const defaultPrimaryModel = "gpt-4.1-mini";
export const defaultRefinementModel = "gpt-4.1-mini";

/**
 * Get the display label for a model value
 */
export function getModelLabel(modelValue: string | undefined | null): string {
    if (!modelValue) return "Unknown Model";

    const option = modelOptions.find((opt) => opt.value === modelValue);
    return option?.label || modelValue;
}

/**
 * Parse model parameters from a URL query string
 */
export function parseModelsFromUrl(url: string | undefined | null): {
    primaryModel: string;
    refinementModel: string;
} {
    if (!url) {
        return {
            primaryModel: defaultPrimaryModel,
            refinementModel: defaultRefinementModel,
        };
    }

    try {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);

        return {
            primaryModel: params.get("model") || defaultPrimaryModel,
            refinementModel: params.get("model2") || defaultRefinementModel,
        };
    } catch (error) {
        // If URL parsing fails, return defaults
        return {
            primaryModel: defaultPrimaryModel,
            refinementModel: defaultRefinementModel,
        };
    }
}
